import { useState, useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip
} from '@mui/material';
import { DateTime } from "luxon";
import { Box, Modal, Button, IconButton } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import "../../../styles/Auth/booking.css";
import getStatusStyle from "../../../utils/statusStyle.js";
import { getData, postData, deleteData, putData } from '../../../webService/webservice.js';
import TVFMLoader from "../Loader/loader.jsx";
import CustomerSelectAsync from "../../../pages/Challange/customerSelectAsync.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import CustomerSelect from "../../Challange/CustomerSelect.jsx";
import ServiceSelect from "../../Challange/ServiceSelect.jsx";
import EmployeeSelect from "../../Challange/EmployeeSelect.jsx";
import AddServiceForm from "../Service/AddServiceForm.jsx";
import AddEmployeeForm from "../Employee/AddEmployeeForm.jsx";
import AddCustomerForm from "../Customers/add-customerForm.jsx";
import BookingHeader from "./booking-header.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
import BookingDetailsPopup from './BookingDetailsPopup.jsx';
import eyeIcon from '@iconify/icons-mdi/eye';
const BookingPage = ({ filters }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Customer Name',
        'Booking time',
        'Location',
        'Status',
        'Action',
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [bookings, setBookings] = useState([]);
    const [isAddBooking, setIsAddBooking] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editBookingId, setEditBookingId] = useState(null);
    const [open, setOpen] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [services, setServices] = useState([]);
    const [users, setUsers] = useState([]);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(5);
    const [BookingToDelete, setBookingToDelete] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = localStorage.getItem("Token");
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const sort = [[sortField, sortOrder]];
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [isAddStore, setIsAddStore] = useState(false);
    const [isAddCustomer, setIsAddCustomer] = useState(false);
    const [isAddService, setIsAddService] = useState(false);
    const [isAddEmployee, setIsAddEmployee] = useState(false);
    const [storeRefreshKey, setStoreRefreshKey] = useState(0);
    const [customerRefreshKey, setCustomerRefreshKey] = useState(0);
    const [serviceRefreshKey, setServiceRefreshKey] = useState(0);
    const [employeeRefreshKey, setEmployeeRefreshKey] = useState(0);
    const [loaderText, setLoaderText] = useState('');
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [showFilter, setShowFilter] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [dynamicRoles, setDynamicRoles] = useState([]);
    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        storeName: "", // Initialize storeName
        customerId: "",
        customerPhone: "",
        customerName: "",
        serviceId: [],
        serviceName: [],
        serviceProvider: "",
        appointmentDate: "",
        employeeId: [],
        employeeName: [],
        timeSlot: "",
        status: "Pending",   // 
        remarks: "",
    });

    const [isBookingDetailsOpen, setIsBookingDetailsOpen] = useState(false);
    const [selectedBookingForDetails, setSelectedBookingForDetails] = useState(null);

    useEffect(() => {
        if (location.state?.isAddBooking) {
            setIsAddBooking(true);
            // Clear state after reading to prevent re-opening on manual refresh if desired
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    useEffect(() => {
        const fetchMissingNames = async () => {
            // Fetch Store Name
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({ ...prev, storeName: res.data.storeName }));
                    }
                } catch (err) { console.error("Failed to fetch store name", err); }
            }

            // Fetch Service Name (for multiple services)
            if (formData.serviceId?.length > 0 && (!formData.serviceName || formData.serviceName.length === 0)) {
                try {
                    const namePromises = formData.serviceId.map(async (id) => {
                        const res = await getData(`services/service/${id}`, {}, sessionToken);
                        return res?.data?.serviceName || "Unknown Service";
                    });
                    const names = await Promise.all(namePromises);
                    setFormData(prev => ({ ...prev, serviceName: names }));
                } catch (err) { console.error("Failed to fetch service names", err); }
            }

            // Fetch Employee Names
            if (formData.employeeId?.length > 0 && (!formData.employeeName || formData.employeeName.length === 0)) {
                try {
                    const namePromises = formData.employeeId.map(async (id) => {
                        if (!id) return "";
                        const res = await getData(`users/user/${id}`, {}, sessionToken);
                        return res?.data?.name || "Unknown";
                    });
                    const names = await Promise.all(namePromises);
                    setFormData(prev => ({ ...prev, employeeName: names }));
                } catch (err) { console.error("Failed to fetch employee names", err); }
            }

            // Fetch Customer Name and Phone
            if (formData.customerId && (!formData.customerName || !formData.customerPhone)) {
                try {
                    const res = await getData(`customers/customer/${formData.customerId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            customerName: res.data.name,
                            customerPhone: res.data.phoneNumber
                        }));
                    }
                } catch (err) { console.error("Failed to fetch customer details", err); }
            }
        };
        fetchMissingNames();
    }, [formData.storeId, formData.serviceId, formData.employeeId, formData.customerId]);

    useEffect(() => {

        if (
            location?.state?.isEditBooking &&
            location?.state?.bookingData
        ) {

            const booking = location.state.bookingData;

            const appointmentDate = booking.appointmentDate
                ? fromUTCToLocal(booking.appointmentDate)
                    .toFormat("yyyy-MM-dd")
                : "";

            const timeSlot = booking.timeSlot
                ? fromUTCToLocal(booking.timeSlot)
                    .toFormat("HH:mm")
                : "";

            const serviceDetails =
                booking.ServiceDetails ||
                booking.serviceDetails ||
                [];

            const employeeDetails =
                booking.EmployeeDetails ||
                booking.employeeDetails ||
                [];

            const customerDetails =
                booking.CustomerDetails ||
                [];

            setFormData({

                storeId:
                    booking.storeId?._id ||
                    booking.storeId ||
                    "",

                storeName:
                    booking.storeDetails?.[0]?.storeName ||
                    "",

                customerId:
                    customerDetails?.[0]?._id || "",

                customerName:
                    customerDetails?.[0]?.name || "",

                customerPhone:
                    customerDetails?.[0]?.phoneNumber || "",

                serviceId:
                    serviceDetails.map(s => s._id),

                serviceName:
                    serviceDetails.map(s => s.serviceName),

                employeeId:
                    employeeDetails.map(e => e._id),

                employeeName:
                    employeeDetails.map(e => e.name),

                appointmentDate,

                timeSlot,

                status:
                    booking.status || "Pending",

                remarks:
                    booking.remarks || ""
            });

            setEditBookingId(booking._id);

            setIsEditMode(true);

            setIsAddBooking(true);
        }

    }, [location.state]);

    const handleOpen = (bookingId) => {
        setBookingToDelete(bookingId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setBookingToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadCustomers = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "customers/customers",
                { page, limit: 100000, search: inputValue, storeId: formData.storeId },
                sessionToken
            );

            const pageData = res?.data?.[0];
            const customers = pageData?.paginatedResults || [];

            const options = customers.map(cus => ({
                value: cus._id,
                label: cus.name,
                phone: cus.phoneNumber
            }));

            return {
                options,
                hasMore: pageData?.currentPage < pageData?.totalPages,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Customer Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadServices = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "services/services",
                { page, limit: 100000, search: inputValue, storeId: formData.storeId, isActive: true },
                sessionToken
            );

            const results = res?.data?.[0]?.paginatedResults || [];
            const activeServices = results.filter(s => s.isActive !== false && s.serviceStatus !== "Inactive");

            const options = activeServices.map(ser => ({
                value: ser._id,
                label: ser.serviceName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Service Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const params = formData.storeId
                    ? { storeId: formData.storeId }
                    : {};

                const response = await getData(
                    "roles",
                    params,
                    sessionToken
                );

                if (response?.data) {
                    setDynamicRoles(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch dynamic roles", error);
            }
        };

        if (sessionToken) {
            fetchRoles();
        }
    }, [sessionToken, formData.storeId]);

    const loadEmployees = async (inputValue, loadedOptions, { page }) => {
        try {

            // Default Roles
            const fixedRoles = [
                "Stylist",
                "Senior Stylist",
                "Beautician"
            ];

            // Dynamic Roles
            const dynamicRoleNames =
                dynamicRoles?.map(r => r.roleName) || [];

            // Merge & Remove Duplicates
            const allowedRoles = [
                ...new Set([
                    ...fixedRoles,
                    ...dynamicRoleNames
                ])
            ];

            const res = await getData(
                "users/users",
                {
                    page,
                    limit: 10,
                    search: inputValue,
                    storeId: formData.storeId,
                    role: allowedRoles,
                    isActive: true
                },
                sessionToken
            );

            const results =
                res?.data?.[0]?.paginatedResults || [];

            const options = results.map(user => ({
                value: user._id,
                label: user.name
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Employee Fetch Failed", err);

            return {
                options: [],
                hasMore: false
            };
        }
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const IST_ZONE = "Asia/Kolkata";

    const toUTCISOString = (date, time) => {
        return DateTime
            .fromFormat(`${date} ${time}`, "yyyy-MM-dd HH:mm", { zone: IST_ZONE })
            .toUTC()
            .toISO();
    };

    const fromUTCToLocal = (iso) => {
        return DateTime
            .fromISO(iso, { zone: "utc" })
            .setZone(IST_ZONE);
    };

    const handleAddBooking = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");

            const appointmentDateISO = formData.appointmentDate;

            const timeSlotISO = toUTCISOString(
                formData.appointmentDate,
                formData.timeSlot
            );


            const bookingData = {
                storeId: formData.storeId,
                serviceId: formData.serviceId,
                customerId: formData.customerId,
                employeeId: formData.employeeId,
                appointmentDate: appointmentDateISO,
                timeSlot: timeSlotISO,
                remarks: formData.remarks,
                status: formData.status
            };

            console.log(" Sending Booking data:", bookingData);

            const response = await postData(
                "appointmentbookings/",
                bookingData,
                token
            );

            if (response?.status !== 200) {
                toast.error(response.message || "Failed to add Booking");
                return;
            }

            toast.success(response.message || "Booking added successfully");
            if (location.state?.fromDashboard) {
                navigate("/dashboard");
            } else {
                setIsAddBooking(false);
            }

            setFormData(prev => ({
                ...prev,
                customerId: "",
                customerName: "",
                customerPhone: "",
                serviceId: [],
                serviceName: [],
                serviceProvider: "",
                employeeId: [],
                employeeName: [],
                appointmentDate: "",
                timeSlot: "",
                status: "Pending",
                remarks: "",
            }));

            setIsAddBooking(false);
            triggerRefresh();
            fetchBookings(
                currentPage,
                limit,
                searchQuery,
                activeFilters,
                selectedStoreId
            );

            alert(isEditMode ? "Booking Updated " : "Booking Added ");

        } catch (error) {
            console.error("Add Booking Error:", error);
            toast.error(error.message || "Add Booking Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };


    useEffect(() => {
        fetchBookings(currentPage, limit, searchQuery, activeFilters, selectedStoreId);
    }, [currentPage, limit, searchQuery, activeFilters, selectedStoreId, sortField, sortOrder, store]);

    const fetchBookings = async (
        page,
        limit,
        searchQuery = "",
        filters = {},
        selectedStoreId = ""
    ) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            search: searchQuery || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };
        if (filters.status) {
            params.status = filters.status;
        }

        if (filters.customerId) {
            params.customerId = filters.customerId;
        }

        if (filters.sortBy) {
            params.sortBy = filters.sortBy;
        }

        if (filters.startDate) {
            params.startDate = filters.startDate;
        }

        if (filters.endDate) {
            params.endDate = filters.endDate;
        }

        const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        try {
            setLoading(true);
            const response = await getData('appointmentbookings/appointmentbookings', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const bookingList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setBookings(bookingList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Booking");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [activeFilters]);

    const handleUpdateBooking = async (e) => {
        e.preventDefault();
        setShowLoader(true);
        try {
            const appointmentDateISO = formData.appointmentDate;

            const timeSlotISO = toUTCISOString(
                formData.appointmentDate,
                formData.timeSlot
            );


            const token = localStorage.getItem("Token");

            const updatedBookingData = {
                storeId: formData.storeId,
                serviceId: formData.serviceId,
                serviceProvider: formData.serviceProvider,
                customerId: formData.customerId,
                employeeId: formData.employeeId,
                appointmentDate: appointmentDateISO,
                timeSlot: timeSlotISO,
                remarks: formData.remarks,
                status: formData.status || "Pending",
            };

            console.log(" Updating Booking with data:", updatedBookingData);

            const response = await putData(
                `appointmentbookings/appointmentbooking/${editBookingId}`,
                updatedBookingData,
                token
            );

            if (response?.success === true || response?.status === 200) {
                toast.success(response.message || "Booking updated successfully");

                setFormData(prev => ({
                    ...prev,
                    customerId: "",
                    customerName: "",
                    customerPhone: "",
                    serviceId: [],
                    serviceName: [],
                    serviceProvider: "",
                    employeeId: [],
                    employeeName: [],
                    appointmentDate: "",
                    timeSlot: "",
                    status: "Pending",
                    remarks: "",
                }));

                setIsEditMode(false);
                setIsPopupMode(false);
                fetchBookings(
                    currentPage,
                    limit,
                    searchQuery,
                    activeFilters,
                    selectedStoreId
                );
                triggerRefresh();
                navigate("/appointments");
            } else {
                toast.error(response?.message || "Failed to update Booking");
            }

        } catch (error) {
            console.error(" Update booking error:", error);
            toast.error(
                error?.response?.data?.message || "Error updating Booking"
            );
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#ffffff',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const handleDeleteBooking = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`appointmentbookings/appointmentbooking/${BookingToDelete}`, token);
            toast.success(response.message || "Booking deleted successfully");
            setBookingToDelete(null);
            fetchBookings(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Booking");
        }
    }

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const validateFields = (data) => {
        let newErrors = {};
        if (!data.appointmentDate) newErrors.appointmentDate = "Appointment Date is required";
        if (!data.timeSlot) newErrors.timeSlot = "TimeSlot is required";
        if (!data.status || data.status.trim() === "") {
            newErrors.status = "Status is required";
        }

        if (data.serviceId && data.serviceId.length > 0) {
            const hasMissingArtist = data.serviceId.some((_, i) => !data.employeeId[i]);
            if (hasMissingArtist) {
                newErrors.employeeId = "Artist is required for all selected services";
            }
        }
        return newErrors;
    }

    const handleDateChangeWithYearCheck = (fieldName, value) => {
        if (!value) {
            setFormData(prev => ({ ...prev, [fieldName]: "" }));
            return;
        }

        // Expected format: YYYY-MM-DD
        const year = value.split("-")[0];

        if (year.length > 4) {
            toast.error("Year should contain only 4 digits");
            return; // 🚫 stop invalid update
        }

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };


    return (
        <div className='product-layout'>
            <div className='product-content'>
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className='product-main'>
                    {isAddBooking ? (
                        <div className='add-Booking-form'>
                            <Typography variant="h6" mb={2}>
                                {
                                    isEditMode
                                        ? "Edit Appointment"
                                        : "Add Appointment"
                                }
                            </Typography>
                            <div className='booking-form-container'>
                                <form className='Booking-form'>
                                    <div className='Booking-form-row'>
                                        <div className="booking-form-group">
                                            <label className="input-label">Store Name</label>
                                            <StoreMultiSelect
                                                value={
                                                    formData.storeId
                                                        ? [{
                                                            value: formData.storeId,
                                                            label: formData.storeName
                                                        }]
                                                        : []
                                                }
                                                onChange={(val) => {
                                                    // ❌ Prevent clearing if only one store
                                                    if (adminStoreIds.length === 1) return;

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        storeId: val?.[0]?.value || "",
                                                        storeName: val?.[0]?.label || "",

                                                    }));
                                                }}
                                                loadStores={loadStores}
                                                loggedInRole={role}
                                                assignedStoreIds={adminStoreIds}
                                                isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                            />
                                        </div>
                                        <div className="booking-form-group">
                                            <label htmlFor="customerId" className="input-label">
                                                Customer Name
                                            </label>

                                            <CustomerSelect
                                                cacheUniqs={[customerRefreshKey]}
                                                value={formData.customerId ? { value: formData.customerId, label: formData.customerName } : null}
                                                onChange={(val) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        customerId: val?.value || "",
                                                        customerName: val?.label || "",
                                                        customerPhone: val?.phone || ""
                                                    }));
                                                }}
                                                loadCustomers={loadCustomers}
                                                onAddCustomer={() => setIsAddCustomer(true)}
                                            />
                                        </div>

                                        <div className="booking-form-group">
                                            <label className="input-label">Mobile Number</label>
                                            <input
                                                type="text"
                                                className="category-input"
                                                value={formData.customerPhone || ""}
                                                placeholder="Customer mobile number"
                                                readOnly
                                            />
                                        </div>


                                        <div className='booking-form-group'>
                                            <label htmlFor="title" className="input-label">
                                                Service Name
                                            </label>
                                            <ServiceSelect
                                                isMulti={true}
                                                cacheUniqs={[serviceRefreshKey]}
                                                value={
                                                    formData.serviceId?.map((id, index) => ({
                                                        value: id,
                                                        label: formData.serviceName[index]
                                                    })) || []
                                                }
                                                onChange={(val) => {
                                                    const newServiceIds = val?.map(v => v.value) || [];
                                                    const newServiceNames = val?.map(v => v.label) || [];
                                                    setFormData(prev => {
                                                        const newEmployeeIds = Array.isArray(prev.employeeId) ? [...prev.employeeId] : [];
                                                        const newEmployeeNames = Array.isArray(prev.employeeName) ? [...prev.employeeName] : [];

                                                        if (newServiceIds.length > prev.serviceId.length) {
                                                            for (let i = prev.serviceId.length; i < newServiceIds.length; i++) {
                                                                newEmployeeIds.push("");
                                                                newEmployeeNames.push("");
                                                            }
                                                        } else {
                                                            newEmployeeIds.length = newServiceIds.length;
                                                            newEmployeeNames.length = newServiceIds.length;
                                                        }

                                                        return {
                                                            ...prev,
                                                            serviceId: newServiceIds,
                                                            serviceName: newServiceNames,
                                                            employeeId: newEmployeeIds,
                                                            employeeName: newEmployeeNames
                                                        };
                                                    });
                                                }}
                                                loadServices={loadServices}
                                                onAddService={() => setIsAddService(true)}
                                            />
                                        </div>

                                    </div>
                                    <div className='Booking-form-row'>

                                    </div>
                                    <div className="Booking-form-row" style={{ display: "block", padding: "0 15px" }}>
                                        {formData.serviceId?.length > 0 && (
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "10px", borderBottom: "1px solid #e2e8f0", paddingBottom: "8px" }}>
                                                <label className="input-label" style={{ marginBottom: 0, fontWeight: "bold" }}>Service</label>
                                                <label className="input-label" style={{ marginBottom: 0, fontWeight: "bold" }}>Artist</label>
                                            </div>
                                        )}
                                        {formData.serviceId?.map((serviceId, index) => (
                                            <div key={index} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", alignItems: "center", marginBottom: "15px" }}>
                                                <div style={{ fontSize: "14px", fontWeight: "500", color: "#1e293b" }}>
                                                    {formData.serviceName[index] || `Service ${index + 1}`}
                                                </div>
                                                <div className="booking-form-group" style={{ marginBottom: 0 }}>
                                                    <EmployeeSelect
                                                        cacheUniqs={[employeeRefreshKey, serviceId]}
                                                        value={formData.employeeId[index] ? { value: formData.employeeId[index], label: formData.employeeName[index] } : null}
                                                        onChange={(val) => {
                                                            setFormData(prev => {
                                                                const newIds = Array.isArray(prev.employeeId) ? [...prev.employeeId] : [];
                                                                const newNames = Array.isArray(prev.employeeName) ? [...prev.employeeName] : [];
                                                                newIds[index] = val?.value || "";
                                                                newNames[index] = val?.label || "";
                                                                return { ...prev, employeeId: newIds, employeeName: newNames };
                                                            });
                                                        }}
                                                        loadEmployees={loadEmployees}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {errors.employeeId && <p className="field-error" style={{ marginTop: "-10px", marginBottom: "15px" }}>{errors.employeeId}</p>}
                                    </div>
                                    <div className='Booking-form-row'>
                                        <div className='booking-form-group'>
                                            <label htmlFor="appointmentDate" className="input-label">
                                                Appointment Date
                                            </label>
                                            <input
                                                type="date"
                                                className="booking-input"
                                                value={formData.appointmentDate || ""}
                                                onChange={(e) =>
                                                    handleDateChangeWithYearCheck("appointmentDate", e.target.value)
                                                }
                                                disabled={loading}
                                            />
                                            {errors.appointmentDate && <p className="field-error">{errors.appointmentDate}</p>}
                                        </div>
                                        <div className='booking-form-group'>
                                            <label htmlFor="timeSlot" className="input-label">
                                                Time Slot
                                            </label>
                                            <input
                                                type="time"
                                                className="booking-input"
                                                value={formData.timeSlot || ""}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        timeSlot: e.target.value,
                                                    });
                                                }}
                                                disabled={loading}
                                            />
                                            {errors.timeSlot && <p className="field-error">{errors.timeSlot}</p>}
                                        </div>
                                        <div className="booking-form-group">
                                            <label className="input-label">Status</label>
                                            <select
                                                id="status"
                                                className="booking-input"
                                                required
                                                disabled={!formData.timeSlot || loading}
                                                value={formData.status}
                                                onChange={(e) => {
                                                    const selectedStatusType = e.target.value;
                                                    setFormData((prev) => ({ ...prev, status: selectedStatusType }))
                                                }}
                                            >
                                                <option value=''>Select status</option>
                                                <option value='Completed'>Completed</option>
                                                <option value='Cancelled'>Cancelled</option>
                                                <option value='Pending'>Pending</option>
                                                <option value='Postponed'>Postponed</option>
                                                <option value='Expired'>Expired</option>
                                            </select>
                                            {errors.status && <p className="field-error">{errors.status}</p>}
                                        </div>
                                    </div>
                                    <div className='Booking-form-row'>
                                        <div className='booking-form-group'>
                                            <label htmlFor="remarks" className="input-label">
                                                Remarks
                                            </label>
                                            <textarea
                                                placeholder="Enter Remarks"
                                                className="booking-input"
                                                value={formData.remarks || ""}
                                                onChange={e => {
                                                    let value = e.target.value;

                                                    // Auto bullet on Enter
                                                    if (value.endsWith("\n")) {
                                                        value += "• ";
                                                    }
                                                    setFormData(prev => ({ ...prev, remarks: value }));
                                                }}
                                                style={{ height: '100px' }}
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                    <div className="Booking-buttons">
                                        <button className="add-Product-button" type="submit" onClick={
                                            isEditMode
                                                ? handleUpdateBooking
                                                : handleAddBooking
                                        } disabled={loading}
                                        >
                                            {loading ? (
                                                <div className='loader'></div>
                                            ) : (
                                                isEditMode ? "Update Appointment" : "Add Appointment"
                                            )}
                                        </button>
                                        <button className="cancel-Product-button" onClick={() => setIsAddBooking(false)} disabled={loading} >
                                            cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>


                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Appointments
                            </Typography>
                            <div className="product-widgets">
                                <div className="product-widgets-header">
                                </div>
                                {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                    <StoreSingleAllStoresSelect
                                        value={store}
                                        onChange={
                                            (store) => {
                                                setStore(store)
                                            }
                                        }
                                    />
                                )}
                                <div className="add-booking-buttons">
                                    <button className="add-btn-booking" onClick={() => setIsAddBooking(true)} >+ Add Appointment</button>
                                    <button className="add-btn-booking" onClick={() => setShowFilter(!showFilter)}>{showFilter ? 'Hide Filter' : 'Show Filter'}</button>
                                </div>
                            </div>
                            {showFilter && (
                                <BookingHeader onApplyFilters={(newFilters) => {
                                    setActiveFilters(newFilters);
                                }} />
                            )}
                            <Box component={Paper}>
                                <TableContainer sx={{
                                    maxHeight: 400,
                                    overflowY: "auto",
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}>
                                    <Table className="custom-product-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isCustomer = heading === "Customer Name";
                                                    const isLocation = heading === "Location";
                                                    const isStatus = heading === "Status"
                                                    const sortKey = isCustomer
                                                        ? "customerId"
                                                        : isLocation
                                                            ? "percentageOrAmount"
                                                            : isStatus
                                                                ? "status"
                                                                : null;

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 10,
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>

                                        </TableHead>
                                        <TableBody>
                                            {bookings.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No Bookings found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                bookings.map((booking, index) => (
                                                    <TableRow key={booking._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{booking.CustomerDetails?.[0]?.name}</Typography></TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {booking.timeSlot
                                                                    ? fromUTCToLocal(booking.timeSlot)
                                                                        .toFormat("dd/MM/yyyy, hh:mm a")

                                                                    : "—"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {booking.storeDetails?.[0]?.storeName}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                const status = booking.status?.toLowerCase();
                                                                const { label } = getStatusStyle(booking.status);
                                                                let bg, color;

                                                                switch (status) {
                                                                    case "in progress":
                                                                        bg = "#3C0008";
                                                                        color = "#fff";
                                                                        break;
                                                                    case "completed":
                                                                    case "approved":
                                                                        bg = "#3C0008";
                                                                        color = "#fff";
                                                                        break;
                                                                    case "pending":
                                                                        bg = "#3C0008";
                                                                        color = "#fff";
                                                                        break;
                                                                    case "cancelled":
                                                                    case "rejected":
                                                                        bg = "#3C0008";
                                                                        color = "#fff";
                                                                        break;
                                                                    case "scheduled":
                                                                    default:
                                                                        bg = "#3C0008";
                                                                        color = "#fff";
                                                                        break;
                                                                }

                                                                return (
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: bg,
                                                                            color: color,
                                                                            fontWeight: 500,
                                                                            padding: '4px 8px',
                                                                            borderRadius: '20px',
                                                                            width: '100px',
                                                                            maxHeight: '70px',
                                                                            fontSize: '12px',
                                                                            textTransform: 'none',
                                                                            boxShadow: 'none',
                                                                            '&:hover': {
                                                                                backgroundColor: bg,
                                                                                boxShadow: 'none',
                                                                            },
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            margin: '0 auto',
                                                                        }}
                                                                    >
                                                                        {label}
                                                                    </Button>
                                                                );
                                                            })()}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
                                                                {(() => {
                                                                    const statusLower = booking.status?.toLowerCase();
                                                                    if (statusLower === 'cancelled' || statusLower === 'expired' || statusLower === 'rejected') {
                                                                        return null;
                                                                    }
                                                                    return (
                                                                        <Tooltip title={statusLower === 'completed' ? "Already Billed" : "Create Bill"}>
                                                                            <IconButton
                                                                                size="small"
                                                                                disabled={statusLower === 'completed'}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if (statusLower === 'completed') {
                                                                                        toast.info("This appointment is already billed/completed.");
                                                                                    } else {
                                                                                        navigate(`/pos?appointmentId=${booking._id}`);
                                                                                    }
                                                                                }}
                                                                                sx={{
                                                                                    color: statusLower === 'completed' ? '#059669' : '#3C0008',
                                                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                                    '&:hover': {
                                                                                        color: statusLower === 'completed' ? '#047857' : '#6366f1',
                                                                                        transform: 'scale(1.2)'
                                                                                    },
                                                                                    '&.Mui-disabled': {
                                                                                        color: '#cbd5e1'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <Icon icon="mdi:receipt-text-plus-outline" width={22} height={22} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    );
                                                                })()}
                                                                <Tooltip title="View Appointment">
                                                                    <Icon
                                                                        icon={plusIcon}
                                                                        width={24}
                                                                        height={24}
                                                                        style={{ cursor: "pointer" }}
                                                                        sx={{
                                                                            color: '#1e293b',
                                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                            '&:hover': {
                                                                                color: '#6366f1',
                                                                                transform: 'scale(1.2) rotate(10deg)',
                                                                                filter: 'drop-shadow(0 0 8px rgba(99, 102, 241, 0.4))'
                                                                            },
                                                                            animation: 'gentlePulse 2s infinite ease-in-out',
                                                                            '@keyframes gentlePulse': {
                                                                                '0%': { opacity: 0.7, transform: 'scale(1)' },
                                                                                '50%': { opacity: 1, transform: 'scale(1.05)' },
                                                                                '100%': { opacity: 0.7, transform: 'scale(1)' }
                                                                            }
                                                                        }}
                                                                        onClick={() => {
                                                                            setSelectedBookingForDetails(booking);
                                                                            setIsBookingDetailsOpen(true);
                                                                        }}
                                                                        title="View Appointment Detailed Profile"
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Appointment">
                                                                    <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                        console.log("edit booking", booking);
                                                                        const appointmentDate = booking.appointmentDate
                                                                            ? fromUTCToLocal(booking.appointmentDate).toFormat("yyyy-MM-dd")
                                                                            : "";


                                                                        const timeSlot = booking.timeSlot
                                                                            ? fromUTCToLocal(booking.timeSlot).toFormat("HH:mm")
                                                                            : "";


                                                                        // Robust extraction for all entities
                                                                        const sId = booking.storeId?._id || booking.storeId || '';
                                                                        const sName = booking.storeDetails?.[0]?.storeName || booking.storeId?.storeName || stores.find(s => s._id === sId)?.storeName || '';

                                                                        const cusDetails = booking.CustomerDetails || booking.customerDetails || [];
                                                                        const cusId = cusDetails?.[0]?._id || booking.customerId?._id || booking.customerId || '';
                                                                        const cusName = cusDetails?.[0]?.name || booking.customerId?.name || '';
                                                                        const cusPhone = cusDetails?.[0]?.phoneNumber || booking.customerId?.phoneNumber || '';

                                                                        const empDetails = booking.EmployeeDetails || booking.employeeDetails || [];
                                                                        const serDetails = booking.serviceDetails || booking.ServiceDetails || [];
                                                                        const serIds = serDetails.length > 0 ? serDetails.map(s => s._id) : (Array.isArray(booking.serviceId) ? booking.serviceId.map(id => id._id || id) : (booking.serviceId ? [booking.serviceId._id || booking.serviceId] : []));
                                                                        const serNames = serDetails.length > 0 ? serDetails.map(s => s.serviceName) : (Array.isArray(booking.serviceId) ? booking.serviceId.map(s => s.serviceName || "") : []);

                                                                        // Extract employee arrays, ensuring length matches serviceIds
                                                                        let empIds = [];
                                                                        let empNames = [];

                                                                        const rawEmployeeId = booking.employeeId;
                                                                        const isEmpArray = Array.isArray(rawEmployeeId);

                                                                        if (isEmpArray && rawEmployeeId.length > 0) {
                                                                            const mappedIds = rawEmployeeId.map(e => e?._id || e || "");

                                                                            const mappedNames = mappedIds.map((id) => {
                                                                                const details = empDetails.find(d => (d._id || d.id) === id);
                                                                                if (details?.name || details?.employeeName) return details.name || details.employeeName;

                                                                                const originalEmp = rawEmployeeId.find(e => (e?._id || e) === id);
                                                                                if (originalEmp?.name || originalEmp?.employeeName) return originalEmp.name || originalEmp.employeeName;

                                                                                return "";
                                                                            });
                                                                            if (mappedIds.length === 1 && serIds.length > 1) {
                                                                                empIds = serIds.map(() => mappedIds[0]);
                                                                                empNames = serIds.map(() => mappedNames[0]);
                                                                            } else {
                                                                                empIds = mappedIds;
                                                                                empNames = mappedNames;
                                                                            }
                                                                        } else if (rawEmployeeId) {
                                                                            const singleId = rawEmployeeId._id || rawEmployeeId;
                                                                            const singleName = empDetails?.[0]?.name || rawEmployeeId?.name || "";
                                                                            empIds = serIds.map(() => singleId);
                                                                            empNames = serIds.map(() => singleName);
                                                                        }

                                                                        // Ensure arrays match service count
                                                                        while (empIds.length < serIds.length) {
                                                                            empIds.push("");
                                                                            empNames.push("");
                                                                        }
                                                                        if (empIds.length > serIds.length) {
                                                                            empIds = empIds.slice(0, serIds.length);
                                                                            empNames = empNames.slice(0, serIds.length);
                                                                        }

                                                                        setFormData({
                                                                            customerId: cusId,
                                                                            customerName: cusName,
                                                                            customerPhone: cusPhone,
                                                                            serviceId: serIds,
                                                                            serviceName: serNames,
                                                                            serviceProvider: booking.serviceProvider || '',
                                                                            storeId: sId,
                                                                            storeName: sName,
                                                                            employeeId: empIds,
                                                                            employeeName: empNames,
                                                                            appointmentDate,
                                                                            timeSlot,
                                                                            status: booking.status || '',
                                                                            remarks: booking.remarks || ''
                                                                        });

                                                                        setEditBookingId(booking._id);
                                                                        setIsPopupMode(true);
                                                                        setIsEditMode(true);
                                                                        setLoaderText("Updating Appointment");
                                                                    }} />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && (
                                                                    <Tooltip title="Delete Appointment">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            onClick={() => handleOpen(booking._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>

                                                        </TableCell>
                                                    </TableRow>

                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="booking-bottom">
                                    <div className="booking-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all" >All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="booking-section showing-range">
                                        {
                                            limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="booking-section spacer"></div>
                                    <div className="booking-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        ><Icon icon='mdi:chevron-double-left' /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        ><Icon icon='mdi:chevron-left' /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        ><Icon icon='mdi:chevron-right' /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        ><Icon icon='mdi:chevron-double-right' /></button>
                                    </div>
                                </div>
                            </Box>
                            {
                                isPopupMode && (
                                    <div className='popup-overlay'>
                                        <div className="popup-wrapper">
                                            <Icon
                                                icon={closeIcon}
                                                className="popup-close-icon-outside"
                                                onClick={() => {
                                                    setIsPopupMode(false);
                                                    setIsEditMode(false);
                                                    setLoaderText("");
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        customerId: "",
                                                        customerName: "",
                                                        customerPhone: "",
                                                        serviceId: [],
                                                        serviceName: [],
                                                        serviceProvider: "",
                                                        employeeId: [],
                                                        employeeName: [],
                                                        appointmentDate: "",
                                                        timeSlot: "",
                                                        status: "Pending",
                                                        remarks: "",
                                                    }));
                                                }}
                                            />
                                            <div className="popup-form">
                                                <Typography variant="h6" mb={4} textAlign='center'>{isEditMode ? "Edit Appointment" : "Add Appointment"}</Typography>
                                                <div className='booking-form-container'>
                                                    <form className="popup-form-body" onSubmit={handleUpdateBooking}>
                                                        <div className="form-group-row">
                                                            <div className="form-group">
                                                                <label htmlFor="title" className="input-label">
                                                                    Customer Name
                                                                </label>
                                                                <CustomerSelect
                                                                    key={formData.storeId || "customer"}
                                                                    cacheUniqs={[customerRefreshKey, formData.storeId]}
                                                                    value={formData.customerId ? { value: formData.customerId, label: formData.customerName } : null}
                                                                    onChange={(val) => {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            customerId: val?.value || "",
                                                                            customerName: val?.label || "",
                                                                            customerPhone: val?.phone || ""
                                                                        }));
                                                                    }}
                                                                    loadCustomers={loadCustomers}
                                                                    onAddCustomer={() => setIsAddCustomer(true)}
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="input-label">Store Name</label>
                                                                <StoreMultiSelect
                                                                    key={storeRefreshKey}
                                                                    value={
                                                                        formData.storeId
                                                                            ? (Array.isArray(formData.storeId)
                                                                                ? formData.storeId.map((id, i) => ({
                                                                                    value: id,
                                                                                    label: Array.isArray(formData.storeName) ? formData.storeName[i] : formData.storeName
                                                                                }))
                                                                                : [{ value: formData.storeId, label: formData.storeName }]
                                                                            )
                                                                            : []
                                                                    }
                                                                    onChange={(val) => {
                                                                        const storeId = val && val.length > 0 ? val[0].value : "";
                                                                        const storeName = val && val.length > 0 ? val[0].label : "";
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            storeId: storeId,
                                                                            storeName: storeName,
                                                                        }));
                                                                    }}
                                                                    loadStores={loadStores}
                                                                    loggedInRole={role}
                                                                    assignedStoreIds={adminStoreIds}
                                                                    onAddStore={() => setIsAddStore(true)}
                                                                    isMulti={false}
                                                                />
                                                                {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                            </div>
                                                            <div className='form-group'>
                                                                <label htmlFor="title" className="input-label">
                                                                    Service Name
                                                                </label>
                                                                <ServiceSelect
                                                                    key={formData.storeId || "service"}
                                                                    isMulti={true}
                                                                    cacheUniqs={[serviceRefreshKey, formData.storeId]}
                                                                    value={
                                                                        formData.serviceId?.map((id, index) => ({
                                                                            value: id,
                                                                            label: formData.serviceName[index]
                                                                        })) || []
                                                                    }
                                                                    onChange={(val) => {
                                                                        const newServiceIds = val?.map(v => v.value) || [];
                                                                        const newServiceNames = val?.map(v => v.label) || [];
                                                                        setFormData(prev => {
                                                                            const newEmployeeIds = Array.isArray(prev.employeeId) ? [...prev.employeeId] : [];
                                                                            const newEmployeeNames = Array.isArray(prev.employeeName) ? [...prev.employeeName] : [];

                                                                            if (newServiceIds.length > prev.serviceId.length) {
                                                                                for (let i = prev.serviceId.length; i < newServiceIds.length; i++) {
                                                                                    newEmployeeIds.push("");
                                                                                    newEmployeeNames.push("");
                                                                                }
                                                                            } else {
                                                                                newEmployeeIds.length = newServiceIds.length;
                                                                                newEmployeeNames.length = newServiceIds.length;
                                                                            }
                                                                            return {
                                                                                ...prev,
                                                                                serviceId: newServiceIds,
                                                                                serviceName: newServiceNames,
                                                                                employeeId: newEmployeeIds,
                                                                                employeeName: newEmployeeNames
                                                                            };
                                                                        });
                                                                    }}
                                                                    loadServices={loadServices}
                                                                    onAddService={() => setIsAddService(true)}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="form-group-row" style={{ display: 'block', padding: '0 10px' }}>
                                                            {formData.serviceId?.length > 0 && (
                                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '10px', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px' }}>
                                                                    <label className='input-label' style={{ marginBottom: 0, fontWeight: 'bold' }}>Service</label>
                                                                    <label className='input-label' style={{ marginBottom: 0, fontWeight: 'bold' }}>Artist</label>
                                                                </div>
                                                            )}
                                                            <div style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '5px', scrollbarWidth: 'thin' }}>
                                                                {formData.serviceId?.map((serviceId, index) => (
                                                                    <div key={index} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'center', marginBottom: '15px' }}>
                                                                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#1e293b' }}>
                                                                            {formData.serviceName[index] || `Service ${index + 1}`}
                                                                        </div>
                                                                        <div className='form-group' style={{ marginBottom: 0 }}>
                                                                            <EmployeeSelect
                                                                                key={`${serviceId}-${index}`}
                                                                                cacheUniqs={[employeeRefreshKey, serviceId]}
                                                                                value={formData.employeeId[index] ? { value: formData.employeeId[index], label: formData.employeeName[index] } : null}
                                                                                onChange={(val) => {
                                                                                    setFormData(prev => {
                                                                                        const newIds = Array.isArray(prev.employeeId) ? [...prev.employeeId] : [];
                                                                                        const newNames = Array.isArray(prev.employeeName) ? [...prev.employeeName] : [];
                                                                                        newIds[index] = val?.value || "";
                                                                                        newNames[index] = val?.label || "";
                                                                                        return { ...prev, employeeId: newIds, employeeName: newNames };
                                                                                    });
                                                                                }}
                                                                                loadEmployees={loadEmployees}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {errors.employeeId && <p className="field-error" style={{ marginTop: '-10px', marginBottom: '15px' }}>{errors.employeeId}</p>}
                                                        </div>
                                                        <div className="form-group-row">
                                                            <div className='form-group'>
                                                                <label htmlFor="appointmentDate" className="input-label">
                                                                    Appointment Date
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="booking-input"
                                                                    value={formData.appointmentDate || ""}
                                                                    disabled={loading}
                                                                    onChange={(e) =>
                                                                        handleDateChangeWithYearCheck("appointmentDate", e.target.value)
                                                                    }
                                                                />
                                                                {errors.appointmentDate && <p className="field-error">{errors.appointmentDate}</p>}
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="timeSlot" className="input-label">
                                                                    Time Slot
                                                                </label>
                                                                <input
                                                                    type="time"
                                                                    className="booking-input"
                                                                    value={formData.timeSlot || ""}
                                                                    disabled={loading}
                                                                    onChange={(e) =>
                                                                        setFormData({ ...formData, timeSlot: e.target.value })
                                                                    }
                                                                />
                                                                {errors.timeSlot && <p className="field-error">{errors.timeSlot}</p>}
                                                            </div>
                                                        </div>
                                                        <div className="form-group-row">
                                                            <div className="form-group">
                                                                <label className="input-label">Status</label>
                                                                <select
                                                                    id="status"
                                                                    className="booking-input"
                                                                    required
                                                                    value={formData.status}
                                                                    disabled={loading}
                                                                    onChange={(e) => {
                                                                        const selectedStatusType = e.target.value;
                                                                        setFormData((prev) => ({ ...prev, status: selectedStatusType }))
                                                                    }}
                                                                >
                                                                    <option value=''>Select status</option>
                                                                    <option value='Completed'>Completed</option>
                                                                    <option value='Cancelled'>Cancelled</option>
                                                                    <option value='Pending'>Pending</option>
                                                                    <option value='Postponed'>Postponed</option>
                                                                    <option value='Expired'>Expired</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-actions">
                                                            <button type="submit" className="add-Product-button" disabled={loading}>
                                                                {loading ?
                                                                    (
                                                                        <div className='loader'></div>
                                                                    ) : (
                                                                        isEditMode ? "Update Appointment" : "Add Appointment"
                                                                    )
                                                                }

                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="cancel-Product-button"
                                                                onClick={() => setIsPopupMode(false)}
                                                                disabled={loading}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this appointment?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteBooking}
                                            className='add-Product-button'
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className='cancel-Product-button'
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )
                    }
                </main >

                <Footer />
            </div >
            <Modal open={isAddStore} onClose={() => setIsAddStore(false)}>
                <Box sx={modalStyle}>
                    <AddStoreForm
                        onSuccess={() => {
                            setIsAddStore(false);
                            setStoreRefreshKey(prev => prev + 1);
                        }}
                        onCancel={() => setIsAddStore(false)}
                    />
                </Box>
            </Modal>

            <Modal open={isAddCustomer} onClose={() => setIsAddCustomer(false)}>
                <Box sx={{ ...modalStyle, width: 800, maxHeight: "90vh", overflowY: "auto" }}>
                    <AddCustomerForm
                        initialStoreId={formData.storeId}
                        onSuccess={(newCus) => {
                            setIsAddCustomer(false);
                            if (newCus) {
                                const newCusData = Array.isArray(newCus) ? newCus[0] : newCus;
                                setFormData(prev => ({
                                    ...prev,
                                    customerId: newCusData._id || newCusData.id,
                                    customerName: newCusData.name || newCusData.customerName || "New Customer",
                                    customerPhone: newCusData.phoneNumber || newCusData.phone || ""
                                }));
                            }
                            setCustomerRefreshKey(prev => prev + 1);
                        }}
                        onCancel={() => setIsAddCustomer(false)}
                    />
                </Box>
            </Modal>

            <Modal open={isAddService} onClose={() => setIsAddService(false)}>
                <Box sx={{ ...modalStyle, width: 800, maxHeight: "90vh", overflowY: "auto" }}>
                    <AddServiceForm
                        initialStoreId={formData.storeId}
                        hideAddCategories={true}
                        onSuccess={(newService) => {
                            setIsAddService(false);
                            if (newService) {
                                const svcData = Array.isArray(newService) ? newService[0] : newService;
                                setFormData(prev => ({
                                    ...prev,
                                    serviceId: [...prev.serviceId, svcData._id || svcData.id],
                                    serviceName: [...prev.serviceName, svcData.serviceName || svcData.name || "New Service"],
                                    employeeId: [...prev.employeeId, ""],
                                    employeeName: [...prev.employeeName, ""]
                                }));
                            }
                            setServiceRefreshKey(prev => prev + 1);
                        }}
                        onCancel={() => setIsAddService(false)}
                    />
                </Box>
            </Modal>

            <Modal open={isAddEmployee} onClose={() => setIsAddEmployee(false)}>
                <Box sx={{ ...modalStyle, width: 800, maxHeight: "90vh", overflowY: "auto" }}>
                    <AddEmployeeForm
                        initialStoreId={formData.storeId}
                        onSuccess={(newEmployee) => {
                            setIsAddEmployee(false);
                            if (newEmployee) {
                                let empData = Array.isArray(newEmployee) ? newEmployee[0] : newEmployee;
                                if (empData && empData.user) {
                                    empData = empData.user;
                                }
                                setFormData(prev => ({
                                    ...prev,
                                    employeeId: [empData._id || empData.id],
                                    employeeName: [empData.employeeName || empData.name || "New Employee"]
                                }));
                            }
                            setEmployeeRefreshKey(prev => prev + 1);
                        }}
                        onCancel={() => setIsAddEmployee(false)}
                    />
                </Box>
            </Modal>

            <BookingDetailsPopup
                open={isBookingDetailsOpen}
                onClose={() => setIsBookingDetailsOpen(false)}
                booking={selectedBookingForDetails}
            />
        </div >
    );
};

export default BookingPage;